

















































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { axiosM, resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import Header from "../../components/project-create-header.vue";
@Component({
  components: {
    Header,
    Copy
  }
})
export default class ProjectCreateFirst extends Vue {
  private projectId: any = "";
  private project: any = {};
  private rules: any = {
    项目名称: [{ required: true, message: "项目名称必填", trigger: "blur" }],
    主要研究者: [{ required: true, message: "主要研究者必填", trigger: "blur" }]
  };
  private cState: "create" | "compose" = "create";
  /**
   * @description 获得项目信息
   */
  private fetch() {
    const params: any = {
      params: {
        project_id: this.projectId
      }
    };
    axios.get("api/project", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.project = data.data;
        if (this.project["开始时间"] && this.project["结束时间"]) {
          this.project["时间"] = [
            this.project["开始时间"],
            this.project["结束时间"]
          ];
        }
      });
    });
  }
  /**
   * @description 前往第二步页面
   */
  private next() {
    (this.$refs.inputForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = this.project;
        if (this.project["时间"]) {
          params["开始时间"] = this.project["时间"][0];
          params["结束时间"] = this.project["时间"][1];
        }
        axios.post("api/project", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.$router.push(
              "/main/project/project-create-second/" + data.data.project_id
            );
          });
        });
      }
    });
  }
  /**
   * @description 保存
   */
  private save() {
    (this.$refs.inputForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = this.project;
        if (this.project["时间"]) {
          params["开始时间"] = this.project["时间"][0];
          params["结束时间"] = this.project["时间"][1];
        }
        axios.post("api/project", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.$message.success("修改成功");
          });
        });
      }
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    this.projectId = this.$route.params.project_id;
    if (this.projectId) {
      this.cState = "compose";
      this.fetch();
    }
  }
}
